import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getSchoolBySelection } from '../../actions/schoolsActions'
import { getPrecandidates, getPrecandidatesByPage, getSelection } from '../../actions/selectionsActions'
import SubMenuSelection from '../../components/menus/SubMenuSelection'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import Swal from 'sweetalert2'
import { addChoose, getReducedChoosesBySelection } from '../../actions/choosesActions'
import CandidateProfile from '../admin/CandidateProfile'
import { editMultiSchoolStock, editStock, getReducedStocksBySchool } from '../../actions/stocksActions'

export default function PreCandidatesSelection() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const params = useParams()
    const dispatch = useDispatch()

    const {school} = useSelector(state=>state.schools)
    const {selection, precandidates, precandidatesLoading} = useSelector(state=>state.selections)
    const {result, chooses} = useSelector(state => state.chooses)
    const {result: stocksResult, stocks} = useSelector(state => state.stocks)

    const [selectedPrecandidate, setSelectedPrecandidate] = useState(null)
    const [filteredCandidates, setFilteredCandidates] = useState([])

    const [multiSchoolStockForm, setMultiSchoolStockForm] = useState(null)

    const loadMoreCandidates = () => {
        dispatch(getPrecandidatesByPage(params.id, Math.ceil(selection.precandidates / precandidates.length)))
    }

    useEffect(() => {
        const filtered = precandidates?.filter(
            (precandidate) =>
                !stocks.some((stock) => stock?.candidate === precandidate?.candidate?._id && stock?.type?.includes("blocked")) &&
                !chooses?.some(choose => choose?.candidate === precandidate?.candidate?._id)
        )
        setFilteredCandidates(filtered)
    }, [precandidates, stocks, chooses])

    const addCandidate = (candidate) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.confirm'),
            denyButtonText: t('global.cancel'),
            icon: 'question',
            text: t('selection.addCandidateQuestion', {name: `${candidate?.firstname} ${candidate?.lastname}`})
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(addChoose(params.id, candidate?._id, 'candidate'))
            }
        })
    }

    const archiveCandidate = (candidate) => {
        dispatch(addChoose(params.id, candidate?._id, 'archive'))
    }

    const handleEditStock = (candidate, movement) => {
        if (client?.rol === "MultiSchool") {
            let typeMovement = ''
            let typeStock = ''

            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
            }
            setMultiSchoolStockForm({
                movement: typeMovement,
                typeStock: typeStock,
                scope: 'all',
                candidate: candidate._id,
            })
        } else {
            let typeMovement = ''
            let typeStock = ''
            let swalText = ''
    
            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
                swalText = t('database.addFavouriteCandidateQuestion')
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
                swalText = t('database.removeFavouriteCandidateQuestion')
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
                swalText = t('database.addBlockCandidateQuestion')
            }
    
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: true,
                confirmButtonText: t('global.confirm'),
                denyButtonText: t('global.cancel'),
                icon: 'question',
                text: t(swalText, {name: `${candidate.firstname} ${candidate.lastname}`})
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(editStock(school?._id, candidate._id, typeStock, typeMovement))
                }
            })
        }
    }

    const handleCloseStockModal = () => {
        setMultiSchoolStockForm(null)
    }

    const handleStockSubmit = (e) => {
        e.preventDefault()
        const formStateCopy = {...multiSchoolStockForm, multiSchool: client?.id}

        if (formStateCopy.scope === "current") {
            formStateCopy.school = school?._id
        }

        dispatch(editMultiSchoolStock(formStateCopy))
    }

    useEffect(() => {
        if(params.id){
            dispatch(getSchoolBySelection(params.id))
        }
    },[dispatch, t, params.id])
    
    useEffect(() => {
        if(school){
            dispatch(getReducedChoosesBySelection(params.id))
            dispatch(getSelection(params.id))
            dispatch(getPrecandidates(params.id))
            dispatch(getReducedStocksBySchool(school?._id))
        }
    },[school, dispatch, params.id])

    useEffect(() => {
        if (result === 'successaddchoose' || result === 'successarchive') {
            dispatch(getReducedChoosesBySelection(params.id))
            setSelectedPrecandidate(null)
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                text: t('selection.' + result)
            })
        }
    }, [result, dispatch, params.id, t])

    useEffect(() => {
        if (stocksResult === "successAddFavourite" || stocksResult === "successRemoveFavourite") {
            dispatch(getReducedStocksBySchool(school?._id))
            setMultiSchoolStockForm(null)
        }
        if (stocksResult === "successAddBlocked") {
            dispatch(getReducedStocksBySchool(school?._id))
            setMultiSchoolStockForm(null)
        }
    }, [stocksResult, dispatch, school])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Configuración" />
                        <h1 className='ms-2 m-0'>{t('menus.activeSelection')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuSelection selection={selection} section="precandidates"/>
                                <Row className='my-3'>
                                    <Col xs={10}>
                                        <div className='d-flex align-items-center'>
                                            <img src="/images/titles-filled.svg" alt="Icono titulos" />
                                            <h4 className='ms-2 m-0'>{t('selection.submenu.precandidates')} <span className="color-primary">({filteredCandidates?.length || 0})</span></h4>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='my-3'>
                                    {
                                        filteredCandidates?.map((precandidate, index) => (
                                            <Col xs={12} md={6} lg={4} key={index} className='my-3'>
                                                <Card className='precandidate'>
                                                    <Card.Body >
                                                        <Row className='my-3'>
                                                            <Col xs={4}>
                                                                <Badge className={`porcentaje ${precandidate?.porcentage > 85 ? 'bg-high' : (precandidate?.porcentage >= 60 ? 'bg-medium' : 'bg-low')}`}>
                                                                    {precandidate?.porcentage}%
                                                                </Badge>
                                                            </Col>
                                                            <Col xs={4}>
                                                                <div className='avatar-mini cursor' onClick={() => setSelectedPrecandidate(precandidate)}>
                                                                    <div className='img-profile' style={{backgroundImage: `url(${precandidate?.user?.image ? precandidate?.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                    {
                                                                       precandidate?.currentSelections > 0 &&
                                                                            <Badge bg='danger' className='number-info' title={t('candidate?.numberSelection')}>{precandidate?.currentSelections}</Badge>
                                                                    }
                                                                </div>
                                                            </Col>
                                                            <Col xs={4}>
                                                                <div className='d-flex justify-content-evenly'>
                                                                    {
                                                                        stocks.some(stock => stock.candidate === precandidate?.candidate?._id && stock.type.includes("favourite"))
                                                                        ?
                                                                            <img src='/images/favourite.svg' alt='Favorito' className='normal-with-hover cursor' onClick={() => handleEditStock(precandidate?.candidate, 'removeFavourite')} />
                                                                        :
                                                                            <img src='/images/favourite.svg' alt='Favorito' className='grey-with-hover cursor' onClick={() => handleEditStock(precandidate?.candidate, 'addFavourite')} />
                                                                    }
                                                                    <img src='/images/block.svg' alt='Favorito' className='grey-with-hover cursor' onClick={() => {handleEditStock(precandidate?.candidate, 'addBlocked')}} />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row className='mt-3 mb-1'>
                                                            <Col className='text-center'>
                                                                { precandidate?.candidate?.firstname } { precandidate?.candidate?.lastname }
                                                            </Col>
                                                        </Row>
                                                        <Row className='mb-3'>
                                                            <Col className='text-muted text-center'>
                                                                <img src='/images/map.svg' alt='map'/> { towns.find(t => t?.value === precandidate?.candidate?.town)?.label } ({provinces.find(t => t?.value === precandidate?.candidate?.province)?.label})
                                                            </Col>
                                                        </Row>
                                                        <Row className='my-3'>
                                                            <Col xs={12} className="d-flex justify-content-between w-100">
                                                                <Button
                                                                    variant='info'
                                                                    className='d-flex align-items-center justify-content-center flex-grow-1 me-2'
                                                                    disabled={chooses?.find(c => c?.candidate === precandidate?.candidate?._id) ? true : false}
                                                                    onClick={() => {
                                                                        if(!chooses?.find(c => c?.candidate === precandidate?.candidate?._id)){
                                                                            archiveCandidate(precandidate?.candidate)}
                                                                        }
                                                                    }
                                                                >
                                                                    <img src='/images/archive.svg' alt='Archivar' className='me-2'/>
                                                                    {t('global.store')}
                                                                </Button>
                                                                <Button
                                                                    variant='success'
                                                                    className='d-flex align-items-center justify-content-center flex-grow-1 ms-2'
                                                                    disabled={chooses?.find(c => c?.candidate === precandidate?.candidate?._id) ? true : false}
                                                                    onClick={() => {
                                                                        if(!chooses?.find(c => c?.candidate === precandidate?.candidate?._id)){
                                                                            addCandidate(precandidate?.candidate)}
                                                                        }
                                                                    }
                                                                >
                                                                    <img src='/images/plus-white.svg' alt='Añadir' className='me-2'/>
                                                                    {t('global.add')}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))
                                    }
                                    {
                                        precandidatesLoading &&
                                        <div className='text-center'>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </div>
                                    }
                                    {

                                        selection?.precandidates > (precandidates?.length || 0) && !precandidatesLoading &&
                                        <Col xs={12} className='d-grid'>
                                            <Button variant='primary' type='button' onClick={loadMoreCandidates}>{t("selection.loadMore")}</Button>
                                        </Col>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={selectedPrecandidate ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
						<div>
							<i className='fa fa-times cursor' onClick={() => setSelectedPrecandidate(null)}></i>
						</div>
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<CandidateProfile candidateToShow={{iduser: selectedPrecandidate?.user?._id}} affinity={selectedPrecandidate?.porcentage} actions={{favourite: handleEditStock, block: handleEditStock, add: () => {if(!chooses?.find(c => c?.candidate === selectedPrecandidate?.candidate?._id)){addCandidate(selectedPrecandidate?.candidate)}}}} favourite={stocks.some(stock => stock.candidate === selectedPrecandidate?.candidate?._id && stock.type.includes("favourite")) ? true : false} selectedCandidate={selectedPrecandidate} selection={params.id}/>
                    <Row className="my-3 d-flex justify-content-end">
                        <Col xs='12' md='6' className='d-flex justify-content-end'>
                            <Button
                                variant='info'
                                className="my-2 me-2 px-4 flex-grow-1"
                                disabled={chooses?.find(c => c?.candidate === selectedPrecandidate?.candidate?._id) ? true : false}
                                onClick={() => {
                                    if(!chooses?.find(c => c?.candidate === selectedPrecandidate?.candidate?._id)){
                                        archiveCandidate(selectedPrecandidate?.candidate)}
                                    }
                                }
                            >
                                <img src='/images/archive.svg' alt='Archivar' className='me-2'/>
                                {t('global.store')}
                            </Button>
                            <Button
                                variant='primary'
                                className="my-2 me-2 px-4 flex-grow-1"
                                onClick={() => {
                                    if(!chooses?.find(c => c?.candidate === selectedPrecandidate?.candidate?._id)){
                                        addCandidate(selectedPrecandidate?.candidate)}
                                    }
                                }
                            >
                                <img src='/images/plus-white.svg' alt='Añadir' className='me-2'/>
                                {t('global.add')}
                            </Button>

                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal size='lg' show={multiSchoolStockForm ? true : false} aria-labelledby="example-custom-modal-styling-title" onHide={handleCloseStockModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("database." + (multiSchoolStockForm?.typeStock === "favourite" ? "addFavourite" : "addBlock"))}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleStockSubmit}>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{t('database.blockedScope')}</Form.Label>
                            <Form.Select
                                className='mb-2'
                                value={multiSchoolStockForm?.scope}
                                onChange={(e) => {
                                    setMultiSchoolStockForm({
                                        ...multiSchoolStockForm,
                                        scope: e.target.value
                                    })
                                }}
                            >
                                <option value="all">{t('database.allSchools')}</option>
                                <option value="current">{t('database.currentSchool', {school: school?.name})}</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='btn btn-secondary' onClick={handleCloseStockModal}>
                            {t('global.cancel')}
                        </button>
                        <button className='btn btn-primary' type='submit'>
                            {t('global.save')}
                        </button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}